'use client';
import { useMemo } from 'react';

/**
 * Hook to check if video uploads are enabled for a creator
 * This hook is designed to be used with creator data passed as a prop
 * @param creatorData - The creator data object containing platform_settings
 * @returns Object containing whether video uploads are enabled
 */
export function useCreatorVideoUploadPermission(creatorData?: {
  platform_settings?: { enable_video_uploads?: boolean };
}) {
  const isVideoUploadEnabled = useMemo(() => {
    const result = creatorData?.platform_settings?.enable_video_uploads || false;

    return result;
  }, [creatorData?.platform_settings?.enable_video_uploads]);

  return {
    isVideoUploadEnabled,
  };
}
